export function getSmallerResolution(productUrl, store) {
  switch (store) {
    case "dots":
      return productUrl.replace(".jpg", "_600x.jpg");
    case "lumi_accessories":
      return productUrl.replace(".jpg", "-600x600.jpg");
    case "centimeter":
      return productUrl.replace(".jpg", "_600x600.jpg");
    case "tauko_design":
      return productUrl.replace(".jpg", "_600x.jpg");
    case "pure_waste":
      return productUrl.replace("/600/800", "/300/400");
    case "ivana_helsinki":
      return productUrl.replace(".jpg", "_600x600.jpg");
    case "marita_huurinainen":
      return insert_marita(productUrl);
    default:
      return productUrl;
  }
}

function insert_marita(productUrl) {
  const product_split = productUrl.split("/");
  product_split.splice(productUrl.split("/").length - 1, 0, "600x600");
  return product_split.join("/");
}
